import styles from './PageHeader.module.scss'
import classNames from 'classnames'
import Image from 'next/image'

import HeaderTextBlock from './HeaderTextBlock'

import bgSrc from '@/img/header-banner-bg.jpg'

export default function PageHeaderBanner({
  title,
  categoryTitle,
  noMargin = false,
}) {
  return (
    <header
      className={classNames(styles.header, {
        [styles['header--noMargin']]: noMargin,
      })}
    >
      <div className={classNames(styles.content, 'container')}>
        <h1 className={classNames(styles.title, 'h1')}>{title}</h1>
        {categoryTitle && (
          <div className={classNames(styles.categoryTitle, 'capText')}>
            {categoryTitle}
          </div>
        )}
      </div>
      <Image
        src={bgSrc}
        alt=""
        className={styles.image}
        placeholder="blur"
        fill
      />
    </header>
  )
}

export { HeaderTextBlock }
